<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true,
              help:
                'Zdjęcie powinno być przycięte do linii logotypu, aby wyświetlało się prawidłowo.'
            }),
            new fields.WYSIWYG({
              label: 'Text',
              modelPath: [this, 'form', 'text'],
              multilingual: true,
              type: 'textarea'
            })
          ]
        }
      ]
    }
  }
}
</script>
